export default __webpack_public_path__ + "static/media/icon-rock.34dcec07.png";